<!-- main-page.component.html -->
<div class="container-lg h-100">
  @if(hasSavedProgress()) {
  <div class="resume-dialog mt-4" [@fadeInOnEnter]>
    <h3 class="mat-title-large">Resume Training</h3>
    <p>
      Would you like to resume from where you left off ({{
        formatTime(lastSavedTime())
      }}) or start from the beginning?
    </p>
    <div
      class="resume-actions mt-4 d-flex justify-content-between align-items-center"
    >
      <button
        mat-stroked-button
        matTooltip="Resume from where you left off"
        matTooltipShowDelay="1000"
        matTooltipTouchGestures="off"
        aria-label="Resume from where you left off"
        (click)="resumeFromSavedTime()"
      >
        <mat-icon>play_arrow</mat-icon> Resume
      </button>
      <button
        mat-stroked-button
        matTooltip="Start from the beginning"
        matTooltipShowDelay="1000"
        matTooltipTouchGestures="off"
        aria-label="Start from the beginning"
        (click)="startNewVideo()"
      >
        <mat-icon>replay</mat-icon> Start New
      </button>
    </div>
  </div>
  } @else {
  <div class="w-100 mt-4">
    @if(!isMobile()) {
    <div class="d-flex justify-content-center">
      <h2 class="text-center mat-display-small" [@fadeInOnEnter]>
        Welcome to the AHA Interactive Stroke Training Module
      </h2>
    </div>
    <div class="d-flex justify-content-center">
      <p class="text-center mat-title-medium" [@fadeInOnEnter]>
        Please watch the video below and answer the questions to complete the
        training.
      </p>
    </div>
    } @else {
    <div class="d-flex justify-content-center">
      <h2 class="text-center mat-title-large" [@fadeInOnEnter]>
        Welcome to the AHA Interactive Stroke Training Module
      </h2>
    </div>
    }
  </div>
  }
</div>
<div class="container-xl h-100">
  <div class="w-100 mt-4">
    <div class="video-container">
      <div class="video-wrapper-outer">
        <div class="video-wrapper-inner">
          <div
            class="w-100 video-wrapper d-flex justify-content-center align-items-center"
            [@fadeInOnEnter]
          >
            <app-video-player
              class="w-100 h-100"
              [lastSavedTime]="lastSavedTime()"
              [allowFullscreen]="false"
              [hasSavedProgress]="hasSavedProgress()"
              [questions]="questions()"
              [isMobile]="isMobile()"
            ></app-video-player>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-lg h-100">
  @if(isMobile()) {
  <div class="w-100 mt-4">
    <div class="d-flex justify-content-center">
      <p class="text-center" [@fadeInOnEnter]>
        Please watch the video above and answer the questions to complete the
        training.
      </p>
    </div>
  </div>
  }

  <div class="w-100  my-4">
    <div class="my-4 d-flex justify-content-center" [@fadeInOnEnter]>
      <img
        ngSrc="/iexcelimages/web/aha-storke-lifeline.svg"
        alt="AHA Lifeline"
        class="img-fluid"
        width="400"
        height="180"
        priority
      />
    </div>

    <div class="disclaimer-container m-4">
      <p class="text-muted" [@fadeInOnEnter]>
        <strong>Disclaimer:</strong> This video is for educational purposes
        only. The information provided in this video is not intended to replace
        professional medical advice, diagnosis, or treatment. If you have any
        concerns or questions about your health, you should always consult with
        a physician or other healthcare professional.
      </p>
    </div>
  </div>
</div>
